import React from 'react';
import ExpenseTypeFormPage from './ExpenseTypeFormPage';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const ExpenseTypeNew: React.FC<ShowAlerts> = () => <ExpenseTypeFormPage mode="new" />;

export default ExpenseTypeNew;
